import Com from "components/styledComp/CommStyledComp";
import React from "react";
import CompImg from "components/comp/CompImg";
import WhyCloudImg from "assets/images/hygateone/why-cloud-tower.jpg";

// why: HyGateOne product overview
const HyGateOneIntro = () => {
  return (
    <Com.DivDetailSection border="false" id="overview">
      <Com.DivDetailHeading>
        <Com.DetailHeading>HyGateOne</Com.DetailHeading>
        <Com.DetailHeadingSmall>
          공간 관리의 새로운 기준, 클라우드 통합 출입 보안 솔루션
        </Com.DetailHeadingSmall>
      </Com.DivDetailHeading>
      <div className="strategy-list">
        <div className="strategy">
          <div className="schedule-dogyo">
            <Com.StrongStrategy underline={true}>제품 소개</Com.StrongStrategy>
            <div className="strategy-desc">
              <p>
                단 하나의 클라우드로 완성되는 완벽한 공간 통제.<br />
                단말기·수기 관리 중심의 물리적 방식에서 벗어나, 웹·모바일로
                출입·권한·현장을 통합 관리합니다.
              </p>
            </div>
            <CompImg img={WhyCloudImg} width="100%" height="auto" fit="contain" />
          </div>
        </div>
        <div className="strategy">
          <div className="schedule-dogyo">
            <Com.StrongStrategy underline={true}>핵심 가치</Com.StrongStrategy>
            <div className="strategy-desc">
              <p>
                <span>관리 효율: </span>데이터 입력·관리 리소스 최대 80% 절감<br />
              </p>
              <p>
                <span>빠른 온보딩: </span>직원 100명 등록·권한 부여를 약 10분 만에 처리<br />
              </p>
              <p>
                <span>원격 관제: </span>전 세계 어디서든 단일 화면으로 모니터링·원격 제어<br />
              </p>
              <p>
                <span>구축 부담 최소화: </span>서버 구축 비용 없이 클라우드 동기화·자동 업데이트
              </p>
            </div>
          </div>
        </div>
      </div>
    </Com.DivDetailSection>
  );
};

export default HyGateOneIntro;
